function statusProducts(btn) {
	const parent = btn
		.closest('.Tabs__block-wrapper')
		.querySelector('.Tabs__block-list')
	if (!parent) return

	const cards = parent.querySelectorAll('.Tabs__block-item')
	cards.forEach(card => card.removeAttribute('style'))
	btn.remove()
}

;(function hiddenTabItems() {
	const parent = document.querySelectorAll('.Tabs__block-wrapper')
	if (!parent.length) return
	try {
		parent.forEach(item => {
			const cards = item.querySelectorAll('.Tabs__block-item')
			const btn = item.querySelector('.Tabs__block-btns')
			if (cards.length > 8) {
				cards.forEach((card, id) =>
					id >= 8 ? (card.style = 'display: none;') : card,
				)
			} else {
				btn.remove()
			}
		})
	} catch (error) {
		// console.log(error)
	}
})()
